import React, {useEffect, useContext} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";
import {ComponentContext} from "../../contexts";
import {custom} from "../../utils/linker";
import FieldRow from "./FieldRow";

function FieldsEditor(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  const compContext = useContext(ComponentContext);

  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  const deleteByIndex=(ind)=> {
    runInAction(()=>{
      compContext.getCurTableFields().splice(ind, 1);
    });
  };


  return (
    <div>
      <div className="bg-w1"></div>
      <table className="w100">
        <tbody>
          {compContext.getCurTableFields().map((item, ind)=>{
            return (
              <FieldRow key={ind} deleteMe={()=>{ deleteByIndex(ind) }} {...custom(compContext.getCurTableFields(), ind)} />
            )
          })}
        </tbody>
      </table>

    </div>
  )
};

FieldsEditor.defaultProps = {};

FieldsEditor.propTypes = {}

export default observer(FieldsEditor);
